import {
  Loadable,
  Model,
  ModelAttributes,
  ModelDescription,
  model,
  modelConfig,
  reference,
} from "@mixitone/oom";
import TournamentCompetition from "./TournamentCompetition";
import { setAccountId } from "./concerns/SetAccountId";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    club_id: {
      type: "string",
    },
    conflict_key: {
      type: "string",
    },
    conflict_type: {
      type: "string",
    },
    created_at: {
      type: "datetime",
    },
    event_ids: {
      type: "json",
      jsonType: [] as string[],
    },
    is_deleted: {
      type: "boolean",
    },
    payload: {
      type: "json",
      jsonType: {} as Record<string, any>,
    },
    status: {
      type: "string",
    },
    tournament_competition_id: {
      type: "string",
    },
    updated_at: {
      type: "datetime",
    },
  },
  {},
  {
    competition: reference(() => TournamentCompetition as any, "tournament_competition_id"),
  },
);

interface TournamentCompetitionConflict extends ModelAttributes<typeof config> {
  competition: Loadable<TournamentCompetition>;
}

@setAccountId
@model("tournament_competition_conflicts", config)
class TournamentCompetitionConflict extends Model<typeof config> {
  static readonly modelDescription: ModelDescription = {
    description:
      "Recorded tournament conflict between non-mergeable events. Open conflicts block automatic progression.",
    availableFields: [...Object.keys(config.fields)],
    relationships: {
      competition: "tournament_competitions where id equals this tournament_competition_id",
    },
  };
}

export default TournamentCompetitionConflict;
